import { useTranslations } from "@jugl-web/utils";
import React from "react";
import { CRMInfoSection } from "../../../../components/CRMInfoSection";
import {
  useVoiceFilters,
  VoiceAgentVoiceFilters,
  VoiceAgentVoicePicker,
} from "../../../../components/VoiceAgentVoicePicker";

export const AIAgentVoiceSection: React.FC = () => {
  const { t } = useTranslations();
  const { filtersProps, pickerProps } = useVoiceFilters();

  return (
    <CRMInfoSection
      title={t({
        id: "client-support-page.ai-agent-voice",
        defaultMessage: "AI Agent Voice",
      })}
      subtitle={t({
        id: "client-support-page.ai-agent-voice-description",
        defaultMessage:
          "Select the voice that represents your Business perfectly.",
      })}
      rightContent={<VoiceAgentVoiceFilters {...filtersProps} />}
    >
      <VoiceAgentVoicePicker name="voice" {...pickerProps} />
    </CRMInfoSection>
  );
};
